import { Outlet } from 'react-router-dom'
import Sidebar from './Sidebar'
import MobileBottomNav from './MobileBottomNav'
import { useAuth } from '@/contexts/AuthContext'
import LoginModal from '@/components/LoginModal'
import LoadingSpinner from '@/components/LoadingSpinner'

export default function AppLayout() {
  const { isAuthenticated, isLoading } = useAuth()

  // 加载中显示全屏加载动画
  if (isLoading) {
    return <LoadingSpinner variant="fullscreen" text="正在验证身份..." />
  }

  // 未登录显示登录模态框 (开发环境下允许跳过)
  const isDev = import.meta.env.DEV
  if (!isAuthenticated && !isDev) {
    return <LoginModal allowClose={false} />
  }

  // 已登录显示正常内容
  return (
    <div className="console-app flex h-[100dvh] w-full overflow-hidden bg-[var(--canvas-fog)]">
      {/* 桌面端左侧导航栏 (隐藏在移动端) */}
      <div className="hidden lg:block">
        <Sidebar />
      </div>

      {/* 主内容区 */}
      <main className="relative flex min-w-0 flex-1 flex-col overflow-hidden">
        {/* 开发环境未登录提示 */}
        {!isAuthenticated && isDev && (
          <div className="z-10 flex min-h-9 shrink-0 items-center justify-center border-b border-[var(--alert-warning-border)] bg-[var(--alert-warning-bg)] px-4 py-2 text-center text-xs text-[var(--alert-warning-text)]">
            ⚠️ 开发环境免登录模式：您当前未登录，部分依赖用户权限的数据可能无法加载
          </div>
        )}

        <div className="min-h-0 flex-1 overflow-y-auto">
          <div className="mx-auto min-h-full max-w-[1680px] p-3.5 pb-[calc(5.75rem+env(safe-area-inset-bottom))] sm:p-5 sm:pb-[calc(5.75rem+env(safe-area-inset-bottom))] lg:p-6 lg:pb-6">
            <Outlet />
          </div>
        </div>
      </main>

      {/* 移动端底部导航栏 (隐藏在桌面端) */}
      <div className="lg:hidden">
        <MobileBottomNav />
      </div>
    </div>
  )
}
